module.exports = __webpack_public_path__ + "img/c1.5bd92971.jpg";